import React from "react";
import {
    Paper,
    BottomNavigation,
    BottomNavigationAction,
    useTheme,
    useMediaQuery,
    alpha,
} from "@mui/material";
import {
    GridViewOutlined as DashboardIcon,
    AssessmentOutlined as ReportsIcon,
    TuneOutlined as SettingsIcon,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";

const DEFAULT_NAV_ITEMS = [
    { label: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
    { label: "Reports", icon: <ReportsIcon />, path: "/reports" },
    { label: "Settings", icon: <SettingsIcon />, path: "/data-setup" },
];

const MobileBottomNav = ({ navItems }) => {
    const NAV_ITEMS = navItems && navItems.length > 0 ? navItems : DEFAULT_NAV_ITEMS;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const navigate = useNavigate();
    const { pathname } = useLocation();

    if (!isMobile) return null;

    const activeIndex = NAV_ITEMS.findIndex((item) =>
        pathname.startsWith(item.path)
    );
    const value = activeIndex === -1 ? 0 : activeIndex;

    return (
        <Paper
            elevation={0}
            sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: (t) => t.zIndex.drawer + 1,
                borderTop: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
                borderRadius: "16px 16px 0 0",
                overflow: "hidden",
                backdropFilter: "blur(12px)",
                bgcolor: alpha(theme.palette.background.paper, 0.95),
            }}
        >
            <BottomNavigation
                value={value}
                onChange={(_, newVal) => navigate(NAV_ITEMS[newVal].path)}
                sx={{
                    height: 64,
                    bgcolor: "transparent",
                    "& .MuiBottomNavigationAction-root": {
                        minWidth: 0,
                        color: theme.palette.text.secondary,
                        fontSize: "0.7rem",
                        fontWeight: 600,
                        py: 1,
                        gap: 0.4,
                        transition: "color 0.2s ease",
                    },
                    "& .MuiBottomNavigationAction-root.Mui-selected": {
                        color: theme.palette.primary.main,
                        "& .MuiBottomNavigationAction-label": {
                            fontSize: "0.7rem",
                            fontWeight: 700,
                        },
                    },
                    "& .MuiBottomNavigationAction-label": {
                        fontSize: "0.7rem",
                        fontWeight: 600,
                        opacity: 1,
                    },
                    "& .MuiSvgIcon-root": {
                        fontSize: "1.5rem",
                    },
                }}
            >
                {NAV_ITEMS.map((item) => (
                    <BottomNavigationAction
                        key={item.label}
                        label={item.label}
                        icon={item.icon}
                    />
                ))}
            </BottomNavigation>
        </Paper>
    );
};

export default MobileBottomNav;
